export const CalendarIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='17'
    height='18'
    fill='none'
    viewBox='0 0 17 18'
  >
    <path
      stroke='#757575'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.3'
      d='M11.483.65v3.333M4.817.65v3.333M.65 6.483h15M3.983 9.817h8.334M3.983 13.15h8.334m1.666-10.833H2.317c-.921 0-1.667.745-1.667 1.666v10.834c0 .92.746 1.666 1.667 1.666h11.666c.921 0 1.667-.746 1.667-1.666V3.983c0-.92-.746-1.666-1.667-1.666'
    ></path>
  </svg>
);
